import React, { useContext, useState } from 'react';
import './login.css';
import { useNavigate } from 'react-router-dom';
import loginBackgroundImage from '../../Assets/Images/loginBackgroundImage.jpg';
import { forgot_pass } from '../../Services/Login/LoginApi';
import AlertModal from '../../Componant/AlertModel';
import { LoaderContext } from '../../Context/ContextProvider';
import SuccessModel from '../../Componant/SuccessModel';
import { clearEventsLogin } from '../../utils/eventsLogin';

const ForgetPassword = () => {
    useState(() => { clearEventsLogin(); return null; });
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [isSuccessOpen, setIsSuccessOpen] = useState(false);
    const [isErrorOpen, setIsErrorOpen] = useState(false);
    const [message, setMessage] = useState('');
    const { setLoader } = useContext(LoaderContext);
    const handleSendResetLink = async () => {
        setError('');
        setMessage('');

        if (!email) {
            setError('Email is required');
            return;
        }

        // Basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Please enter a valid email address');
            return;
        }

        try {
            setLoader(true)
            // Call your forgot password API
            const response = await forgot_pass({ email: email });

            if (response?.success) { // Assuming your API returns a success flag
                setMessage('Password reset link sent successfully to your email.');
                setIsSuccessOpen(true);
                setEmail(''); // Optionally clear the email field
            } else {
                setMessage(response?.message || 'Failed to send reset link. Please try again.');
                setIsErrorOpen(true);
            }
            setLoader(false)
        } catch (err) {
            if (err.response && err.response.status === 401) {
                setMessage('Error! Use Log In with Google');
            } else {
                setMessage(err.response?.data?.message || err.response?.data?.error || 'Something went wrong. Please try again later.');
            }
            setIsErrorOpen(true);
            setLoader(false)
            console.error(err);
        }
    };

    return (
      <div className="signup-wrapper">
        <div className="signup-card">
          <div className="signup-left">
            <img src={loginBackgroundImage} alt="Sign Up Visual" className="inline-logo" />
            <div className="info-cards">
              <div className="info-card">
                <span className="info-card-value">2x</span>
                <br />
                <span className="info-card-label">Job Matches</span>
              </div>
              <div className="info-card">
                <span className="info-card-value">50%</span>
                <br />
                <span className="info-card-label">Time Saving in Job Searches</span>
              </div>
              <div className="info-card">
                <span className="info-card-value">95%</span>
                <br />
                <span className="info-card-label">Score on mostly all ATS</span>
              </div>
              <div className="info-card">
                <span className="info-card-value">50%</span>
                <br />
                <span className="info-card-label">More Interview Invites</span>
              </div>
            </div>
          </div>

          <div className="signup-right">
            <h2 onClick={() => navigate('/')} className="welcome-heading">
              <img src={`${process.env.PUBLIC_URL}/assets/images/logo/SeekJobsLog1.png`} alt="SeekJobs" className="inline-logo" />
            </h2>
            <h3>Forgot your password? No worries, we’ll get you right back in!</h3>
            <form className="signup-form" onSubmit={(e) => { e.preventDefault(); handleSendResetLink(); }}>
              <div className="form-group-login">
                <label className="login-label" htmlFor="email">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email"
                  className="password-input"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
                {error && <div className="text-danger text-start">{error}</div>}
              </div>
              <small className="text-muted">Fill in your email and we'll send you a link to reset your password</small>
              <button type="submit" className="primary-btn" style={{ cursor: 'pointer' }}>
                Send
              </button>
            </form>
          </div>
          <SuccessModel
            isOpen={isSuccessOpen}
            title="Success!"
            message={message}
            buttonText="OK"
            onClose={() => {
              navigate('/');
              setIsSuccessOpen(false);
            }}
          />
          <AlertModal
            isOpen={isErrorOpen}
            title="Alert!"
            message={message}
            buttonText="Got it"
            onClose={() => setIsErrorOpen(false)}
          />
        </div>
      </div>
    );
};

export default ForgetPassword;
